<div class="container">

  <app-header-dialog [iconName]="'account_tree'">
    {{ local_title }}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>account_tree</mat-icon>
          <div>GN1 - Cadastro</div>
        </ng-template>

        <div class='tab-content'>

          <mat-form-field class="full-width">
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              placeholder="Nome" autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O Nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.category"
              placeholder="Categoria" autocomplete="off">
            <mat-error *ngIf="entityForm.controls.category.hasError('required')">
              A Categoria é obrigatória.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.cpf"
              placeholder="CPF" autocomplete="off">
            <mat-error *ngIf="entityForm.controls.cpf.hasError('required')">
              O CPF é obrigatório.
            </mat-error>
          </mat-form-field>

          <mat-checkbox color='primary' [formControl]="entityForm.controls.exclude">
            Excluído
          </mat-checkbox>

        </div>

      </mat-tab>

    </mat-tab-group>

  </form>


  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)="matDialogRef.close(['ok',entityForm])" [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>